import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { tagsSchema } from "./schema";
import { fetchTagData } from "./read";
import { useUpdateTag } from "../update/mutation";
import { useCreateTag } from "../create/mutation";

export const useTagsForm = ({ tagId }) => {
  const form = useForm({
    resolver: zodResolver(tagsSchema),
    defaultValues: {
      label: "",
      color: "",
      for: "timesheet",
    },
  });

  const updateTag = useUpdateTag();
  const createTag = useCreateTag();

  const handleCreate = async (context) => {
    const item = context.values;
    await createTag.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateTag.mutateAsync({ tagId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchTagData({ tagId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
